import { render, staticRenderFns } from "./BSTagsInput.vue?vue&type=template&id=3afaea21&"
import script from "./BSTagsInput.vue?vue&type=script&lang=js&"
export * from "./BSTagsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BSTagsInput.vue"
export default component.exports